module.exports = __webpack_public_path__ + "static/TECH-99f7c74a97c07fbb6074a2d64bf4f2cb.png";